<template>
  <p class="ma-0 error--text d-flex align-center" style="font-size: 0.8rem; height: 30px">
    <span
      ><slot :error="error">{{ error }}</slot></span
    >
  </p>
</template>

<script>
export default {
  name: 'ErrorMessages',

  props: {
    error: {
      type: String || null,
      required: true,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped></style>
